export const unHash = (id: string) => {
	return !id?.startsWith('#') ? id : id.slice(1);
};
